import React from 'react';
import Select from 'react-select';

// Dynamic Select Component
const DynamicSelect = ({
  values,
  handleChange,
  data, // The array of options
  errors,
  touched,
  valueField, // Field for the option value (e.g., 'id' or 'category')
  labelField, // Field for the option label (e.g., 'name' or 'categoryName')
  name, // Field name for the select input
  placeholder, // Custom placeholder text
}) => {
  // Transform data to the format expected by react-select
  const options = data?.map((item) => ({
    value: item[valueField], // Dynamically use the valueField
    label: capitalizeFirstLetter(item[labelField]), // Dynamically use the labelField
  }));

  // Pre-fill selected values based on ids in 'values'
  const prefilledValues = options.filter(option => values?.includes(option.value));

  // Handle the onChange for react-select
  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.value);
    handleChange({
      target: { name, value: selectedValues }
    });
  };

  console.log('values', values)
  console.log('prefilledValues', prefilledValues)

  return (
    <>
      <Select
        isMulti
        name={name}
        value={prefilledValues} // Set prefilled values here
        onChange={handleSelectChange}
        options={options}
        placeholder={placeholder || "Select"} // Default placeholder text
        className="cp"
      />
      {errors[name] && touched[name] && (
        <span className="text-danger d-flex text-left">
          {errors[name]}
        </span>
      )}
    </>
  );
};

// Helper function to capitalize the first letter of a string
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export default DynamicSelect;
